import React from 'react'
import { useTranslation } from 'react-i18next'
import MainHeader, { MENU_WOOD_EXPORT } from '../components/common/MainHeader'
import ExportTransactionList from '../components/wood-export/ExportTransactionList';
import Title from 'antd/es/typography/Title';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';


export default function ExportTransactionListView(props) {
  const { t } = useTranslation();

  return (
    <div>
      <MainHeader activeItem={MENU_WOOD_EXPORT} />
      <Layout>
        <Content style={{ margin: '24px', marginTop: '7em' }}>
          <Title level={2}>{t('menus.wood_menus.export_transaction')}</Title>
          <ExportTransactionList />
        </Content>
      </Layout>

    </div>
  )
}
